// блок плиток с застройщиками
function devBlockShow() {
    // проверяем наличие на странице плиток с застройщиками
    if ($('.dev-block__item').length === 0) return;

    // слушаем клики по документу
    $(document).on('click', function(event) {
        var devItem = event.target.closest('.dev-block__item')

        // обрабатываем условие, кликнули по плитке или нет
        if (!devItem) {
            $('.dev-block__item').removeClass('dev-block__item_show')
        } else {
            $('.dev-block__item').removeClass('dev-block__item_show')
            $(devItem).addClass('dev-block__item_show')
        }
    });
}

devBlockShow()
